"use client";

import { ArticleLayoutType } from "@/util/query/general-styles-query";
import React, { createContext, ReactNode, useEffect, useState, useContext } from "react";

export type ArticleLayoutStylesInput = Partial<ArticleLayoutType> | null | undefined;

const ArticleLayoutStyleContext = createContext<ArticleLayoutType>({} as ArticleLayoutType);


export const ArticleLayoutProvider = ({
    children,
    articleLayoutStyle,
}:{
    children: ReactNode;
    articleLayoutStyle: ArticleLayoutStylesInput;
}) => {
    const [data, setData] = useState<ArticleLayoutType>({
        articlePageColumns: 3,
        articlePageRows: 3,
        articleCarouselColumns: 4,
        arrowPosition: "BOTTOM",
    });
    

    useEffect(() => {
        if (!articleLayoutStyle) return;

        setData((prev) => ({
            articlePageColumns: articleLayoutStyle.articlePageColumns ?? prev.articlePageColumns,
            articlePageRows: articleLayoutStyle.articlePageRows ?? prev.articlePageRows,
            articleCarouselColumns: articleLayoutStyle.articleCarouselColumns ?? prev.articleCarouselColumns,
            arrowPosition: articleLayoutStyle.arrowPosition ?? prev.arrowPosition,
        }));
    }, [articleLayoutStyle]);

    return (
        <ArticleLayoutStyleContext.Provider value={data}>
            {children}
        </ArticleLayoutStyleContext.Provider>
    );
}

export default ArticleLayoutStyleContext;

export const useArticleLayout = () => useContext(ArticleLayoutStyleContext);
